export const dummyData = {
    "companyName": [
        "Acme Corporation",
        "Acme Corp",
        "Acme Corporatin",
        "Acme Corration",
        "Acme Corporation",
        "Acme Corpoon",
        "Acme Corporaon",
        "Acme Corporation"
    ],
    "dates": [
        "2025-01-05",
        "2025-01-12",
        "2025-01-19",
        "2025-01-26",
        "2025-02-02",
        "2025-02-09",
        "2025-02-16",
        "2025-02-23",
        "2025-03-02",
        "2025-03-09",
        "2025-03-16",
        "2025-03-23"
    ],
    "formattedDates": [
        "05 Jan",
        "12 Jan",
        "19 Jan",
        "26 Jan",
        "02 Feb",
        "09 Feb",
        "16 Feb",
        "23 Feb",
        "02 Mar",
        "09 Mar",
        "16 Mar",
        "23 Mar"
    ],
    "seriesData": [
        {
            "x": 11,
            "y": 0,
            "value": 0,
            "date": "2025-03-23",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 10,
            "y": 0,
            "value": 0,
            "date": "2025-03-16",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 9,
            "y": 0,
            "value": 0,
            "date": "2025-03-09",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 8,
            "y": 0,
            "value": 0,
            "date": "2025-03-02",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 7,
            "y": 0,
            "value": 0,
            "date": "2025-02-23",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 6,
            "y": 0,
            "value": 0,
            "date": "2025-02-16",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 5,
            "y": 0,
            "value": 0,
            "date": "2025-02-09",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 4,
            "y": 0,
            "value": 0,
            "date": "2025-02-02",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 3,
            "y": 0,
            "value": 0,
            "date": "2025-01-26",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 2,
            "y": 0,
            "value": 0,
            "date": "2025-01-19",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 1,
            "y": 0,
            "value": 0,
            "date": "2025-01-12",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 0,
            "y": 0,
            "value": 0,
            "date": "2025-01-05",
            "clientId": "9b269d68-2e23-46a5-903a-27c3b50f221e"
        },
        {
            "x": 11,
            "y": 1,
            "value": 0,
            "date": "2025-03-23",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 10,
            "y": 1,
            "value": 0,
            "date": "2025-03-16",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 9,
            "y": 1,
            "value": 0,
            "date": "2025-03-09",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 8,
            "y": 1,
            "value": 0,
            "date": "2025-03-02",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 7,
            "y": 1,
            "value": 0,
            "date": "2025-02-23",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 6,
            "y": 1,
            "value": 0,
            "date": "2025-02-16",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 5,
            "y": 1,
            "value": 0,
            "date": "2025-02-09",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 4,
            "y": 1,
            "value": 0,
            "date": "2025-02-02",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 3,
            "y": 1,
            "value": 0,
            "date": "2025-01-26",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 2,
            "y": 1,
            "value": 0,
            "date": "2025-01-19",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 1,
            "y": 1,
            "value": 0,
            "date": "2025-01-12",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 0,
            "y": 1,
            "value": 0,
            "date": "2025-01-05",
            "clientId": "033d86a9-9f29-448f-8f9f-8fec5a3554e3"
        },
        {
            "x": 11,
            "y": 2,
            "value": 0,
            "date": "2025-03-23",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 10,
            "y": 2,
            "value": 0,
            "date": "2025-03-16",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 9,
            "y": 2,
            "value": 0,
            "date": "2025-03-09",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 8,
            "y": 2,
            "value": 0,
            "date": "2025-03-02",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 7,
            "y": 2,
            "value": 0,
            "date": "2025-02-23",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 6,
            "y": 2,
            "value": 0,
            "date": "2025-02-16",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 5,
            "y": 2,
            "value": 0,
            "date": "2025-02-09",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 4,
            "y": 2,
            "value": 0,
            "date": "2025-02-02",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 3,
            "y": 2,
            "value": 0,
            "date": "2025-01-26",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 2,
            "y": 2,
            "value": 0,
            "date": "2025-01-19",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 1,
            "y": 2,
            "value": 0,
            "date": "2025-01-12",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 0,
            "y": 2,
            "value": 0,
            "date": "2025-01-05",
            "clientId": "9f1c90b1-3829-41de-8cd1-e64f07de69c1"
        },
        {
            "x": 11,
            "y": 3,
            "value": 0,
            "date": "2025-03-23",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 10,
            "y": 3,
            "value": 0,
            "date": "2025-03-16",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 9,
            "y": 3,
            "value": 0,
            "date": "2025-03-09",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 8,
            "y": 3,
            "value": 0,
            "date": "2025-03-02",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 7,
            "y": 3,
            "value": 0,
            "date": "2025-02-23",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 6,
            "y": 3,
            "value": 0,
            "date": "2025-02-16",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 5,
            "y": 3,
            "value": 0,
            "date": "2025-02-09",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 4,
            "y": 3,
            "value": 3.62,
            "date": "2025-02-02",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 3,
            "y": 3,
            "value": 0,
            "date": "2025-01-26",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 2,
            "y": 3,
            "value": 0,
            "date": "2025-01-19",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 1,
            "y": 3,
            "value": 0,
            "date": "2025-01-12",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 0,
            "y": 3,
            "value": 1.07,
            "date": "2025-01-05",
            "clientId": "aec2ea24-1f9f-486d-9937-b35ffb6f7bad"
        },
        {
            "x": 11,
            "y": 4,
            "value": 0,
            "date": "2025-03-23",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 10,
            "y": 4,
            "value": 0,
            "date": "2025-03-16",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 9,
            "y": 4,
            "value": 0,
            "date": "2025-03-09",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 8,
            "y": 4,
            "value": 0,
            "date": "2025-03-02",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 7,
            "y": 4,
            "value": 0,
            "date": "2025-02-23",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 6,
            "y": 4,
            "value": 0,
            "date": "2025-02-16",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 5,
            "y": 4,
            "value": 0,
            "date": "2025-02-09",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 4,
            "y": 4,
            "value": 0,
            "date": "2025-02-02",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 3,
            "y": 4,
            "value": 0,
            "date": "2025-01-26",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 2,
            "y": 4,
            "value": 0,
            "date": "2025-01-19",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 1,
            "y": 4,
            "value": 0,
            "date": "2025-01-12",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 0,
            "y": 4,
            "value": 0,
            "date": "2025-01-05",
            "clientId": "526d6ea8-2a44-4aed-bdaf-603d58370a0f"
        },
        {
            "x": 11,
            "y": 5,
            "value": 0,
            "date": "2025-03-23",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 10,
            "y": 5,
            "value": 0,
            "date": "2025-03-16",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 9,
            "y": 5,
            "value": 0,
            "date": "2025-03-09",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 8,
            "y": 5,
            "value": 0,
            "date": "2025-03-02",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 7,
            "y": 5,
            "value": 0,
            "date": "2025-02-23",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 6,
            "y": 5,
            "value": 0,
            "date": "2025-02-16",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 5,
            "y": 5,
            "value": 0,
            "date": "2025-02-09",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 4,
            "y": 5,
            "value": 0,
            "date": "2025-02-02",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 3,
            "y": 5,
            "value": 0,
            "date": "2025-01-26",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 2,
            "y": 5,
            "value": 0,
            "date": "2025-01-19",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 1,
            "y": 5,
            "value": 0,
            "date": "2025-01-12",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 0,
            "y": 5,
            "value": 0,
            "date": "2025-01-05",
            "clientId": "af370616-c087-4362-9dde-86057b7bf647"
        },
        {
            "x": 11,
            "y": 6,
            "value": 0,
            "date": "2025-03-23",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 10,
            "y": 6,
            "value": 0,
            "date": "2025-03-16",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 9,
            "y": 6,
            "value": 0,
            "date": "2025-03-09",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 8,
            "y": 6,
            "value": 0,
            "date": "2025-03-02",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 7,
            "y": 6,
            "value": 0,
            "date": "2025-02-23",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 6,
            "y": 6,
            "value": 0,
            "date": "2025-02-16",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 5,
            "y": 6,
            "value": 0,
            "date": "2025-02-09",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 4,
            "y": 6,
            "value": 0,
            "date": "2025-02-02",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 3,
            "y": 6,
            "value": 0,
            "date": "2025-01-26",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 2,
            "y": 6,
            "value": 0,
            "date": "2025-01-19",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 1,
            "y": 6,
            "value": 0,
            "date": "2025-01-12",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 0,
            "y": 6,
            "value": 0,
            "date": "2025-01-05",
            "clientId": "d2929e85-5767-458c-b761-7c82bf36665b"
        },
        {
            "x": 11,
            "y": 7,
            "value": 0,
            "date": "2025-03-23",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 10,
            "y": 7,
            "value": 0,
            "date": "2025-03-16",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 9,
            "y": 7,
            "value": 0,
            "date": "2025-03-09",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 8,
            "y": 7,
            "value": 0,
            "date": "2025-03-02",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 7,
            "y": 7,
            "value": 0,
            "date": "2025-02-23",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 6,
            "y": 7,
            "value": 0,
            "date": "2025-02-16",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 5,
            "y": 7,
            "value": 0,
            "date": "2025-02-09",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 4,
            "y": 7,
            "value": 0,
            "date": "2025-02-02",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 3,
            "y": 7,
            "value": 0,
            "date": "2025-01-26",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 2,
            "y": 7,
            "value": 0,
            "date": "2025-01-19",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 1,
            "y": 7,
            "value": 0,
            "date": "2025-01-12",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        },
        {
            "x": 0,
            "y": 7,
            "value": 0,
            "date": "2025-01-05",
            "clientId": "1c73e29b-905f-45ae-9d31-554e6fe8ea69"
        }
    ]
}